import { forwardRef } from "react";
import type { ShowcaseProblem } from "../../types.ts";
import { SlideEyebrow, SlideHeading } from "../common.tsx";

interface Props {
  index: number;
  problem: ShowcaseProblem;
}

export const ProblemSlide = forwardRef<HTMLElement, Props>(function ProblemSlide(
  { index, problem },
  ref
) {
  return (
    <section ref={ref} className="dz-slide">
      <div className="dz-container">
        <SlideEyebrow index={index} label="The Problem" />
        <SlideHeading plain="The status quo is broken and expensive." />
        <div className="dz-problem-grid">
          <div className="dz-quote-card">
            <p>{problem.statement}</p>
          </div>
          <div className="dz-who-card">
            <div className="dz-who-card__label">Who feels it</div>
            <p className="dz-who-card__text">{problem.whoFeelsIt}</p>
          </div>
        </div>
      </div>
    </section>
  );
});

